/**
 * Redux selector to get the list of MAT clients
 * @param {RootState} state - The root Redux state
 * @returns {MAT.Client[]} Array of MAT client objects
 */
export const getclient = (state: RootState) => {
	return state.mat.clients;
};

/**
 * Redux selector to get the selected academic year
 * @param {RootState} state - The root Redux state
 * @returns {number} The selected academic year
 */
export const getYear = (state: RootState) => {
	return state.mat.selectedYear;
};

/**
 * Redux selector to get the currently selected MAT client
 * @param {RootState} state - The root Redux state
 * @returns {MAT.Client | null} The selected MAT client object or null if none selected
 */
export const selectedClient = (state: RootState) => {
	return state.mat.selectedClient;
};

/**
 * Redux selector to get the reports for the selected MAT client
 * @param {RootState} state - The root Redux state
 * @returns {MAT.Report[] | undefined} Array of reports for the selected client
 */
export const getReports = (state: RootState) => {
	return state.mat.selectedClient?.reports;
};

/**
 * Redux selector to get the loading state
 * @param {RootState} state - The root Redux state
 * @returns {boolean} True if data is loading, false otherwise
 */
export const isLoading = (state: RootState) => {
	return state.mat.loading;
};

/**
 * Redux selector to get data uploads for child schools of MAT clients
 * @param {RootState} state - The root Redux state
 * @returns {MAT.DataUploads[]} Array of data upload information for child schools
 */
export const getDataUploadsForClientSchools = (state: RootState) => {
	return state.mat.dataUploadsForChildren;
};

/**
 * Redux selector to get groups reports
 * @param {RootState} state - The root Redux state
 * @returns {ReportBundle[]} Array of groups reports
 */
export const getGroupsReports = (state: RootState) => {
	return state.mat.groupsReports ?? [];
};

/**
 * Redux selector to get the report request pending status
 * @param {RootState} state - The root Redux state
 * @returns {MAT.ReportRequestPendingStatus} The report request pending status
 */
export const getReportRequestPending = (state: RootState) => {
	return state.mat.reportRequestPending;
};

/**
 * Redux selector to get the report request error
 * @param {RootState} state - The root Redux state
 * @returns {string} The report request error
 */
export const getReportRequestError = (state: RootState) => {
	return state.mat.reportRequestError;
};

/**
 * Redux selector to get whether there are new group reports available or not
 * @param {RootState} state - The root Redux state
 * @returns {boolean} True if new reports are available for activation, false if not
 */
export const getHasNewGroupReportsAvailable = (state: RootState): boolean => {
	return state.mat.hasNewGroupReports;
};

/**
 * Redux selector to get the show report info
 * @param {RootState} state - The root Redux state
 * @returns {boolean} The show report info
 */
export const getShowReportInfo = (state: RootState) => {
	return state.mat.showReportInfo;
};
